<nb-form-field *ngIf="searchEnabled && !disabled">
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput fieldSize="small" fullWidth [formControl]="filterControl" placeholder="Search..." />
    <button nbSuffix nbButton ghost (click)="filterControl.reset()">
        <nb-icon [icon]="'close'" pack="eva" [attr.aria-label]="'clear search field'"></nb-icon>
    </button>
</nb-form-field>

<ngx-icon-box
    *ngIf="selectAllEnabled && !disabled"
    (click)="changeSelection()"
    class="select-all-items"
    [title]="isAllSelected ? 'Unselect All' : 'Select All'"
    [icon]="isAllSelected ? 'square-outline' : 'checkmark-square-2-outline'"
></ngx-icon-box>
<nb-list nbInfiniteList [threshold]="300" (bottomThreshold)="loadNext()">
    <nb-list-item *ngFor="let item of displayOptions$ | async">
        <nb-checkbox
            [disabled]="disabled"
            (checkedChange)="selectCheckbox(item, $event)"
            [checked]="selectedOptions.includes(item)"
        >
            {{ item.name }}
        </nb-checkbox>
    </nb-list-item>
</nb-list>
